import { format, parseISO } from "date-fns";
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCheckbox, MDBChip, MDBCol, MDBToast, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBSelect, MDBTable, MDBTableBody, MDBTableHead, MDBTooltip, MDBRadio } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { browserName, browserVersion } from "react-device-detect";

import { useLocation, useNavigate } from "react-router";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import Loader from "../components/Loader";
import Popup from "../components/Popup";
import CreateMember from "../components/createMember";
import ExcelExportButton from "../components/exportToExcel.js";
import { formatDate } from '../utils/DateFormat';
import {
  deleteMember, getGymAddonsList, getWaiver, logEvent, membertable, getGymPlansList, allsessions,
  sendWhatsappmessage,
  getWhatsAppTEMP,
  getappvariables,
  createImportedMember,
  createSegment,
  getSegment
} from "../services/apiServices.js";
import addImg from "./../components/images/add.svg";
import deleteImg from "./../components/images/delete.svg";
import editImg from "./../components/images/edit.svg";
import VeiwWaiverForm from "./veiwWaiverForm";
import DatePicker from "react-datepicker";
import calImg from "./../components/images/calendar.svg";
import PageError from "./PageError";
import ExcelJS from 'exceljs';
import ImportExcelModal from "../components/ImportExcelModal"
import { BasePlanName, resolvePlanAndSubplan } from "../utils/BasePlanName";
import CustomMultiSelectDropdown from "./CustomMultiSelectDropdown";
import { useAnalytics } from "../hooks/useAnalytics";
import { useAccess } from "../context/AccessContext";

const MManger = () => {
  const searchRef = useRef();
  const { trackButtonClick } = useAnalytics();
  const [memberData, setData] = useState([]);
  const [addandSave, setaddandSave] = useState(1);
  const [mId, setMId] = useState(null);
  const [sFlag, setFlag] = useState(0);
  const [toggle, setToggle] = useState(false)
  const [Date11, setDate11] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [Date22, setDate22] = useState(new Date());
  const [checkFilter, setCheckFilter] = useState(false)
  const [age, setAge] = useState({
    fage: "",
    tage: ""
  })
  const [selectData, setSelectData] = useState([
    { text: 'Select', value: "Select" },
  ]);
  const [selectValue, setSelectValue] = useState([]);
  const [campainName, setCampainName] = useState("")
  const [WaiverPopup, setWaiverPopup] = useState(false)
  const [formData, setFormData] = useState({})
  const [mfilter, setMfilter] = useState({
    tidName: "",
    planNme: [],
    gender: "",
    status: "",
    Ttype: "",
    inputText: "",
    mType: "",
    transtype: "",
    planType: "",
  })

  console.log("mfiltermfilter", mfilter);

  const [numberData, setNumberData] = useState([])
  const [filterr, setFilterr] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [valuee, setValuee] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalCount, setTotalcount] = useState(0)
  const [totalPages, setTotalPages] = useState(1);
  const [padata, setPadata] = useState([])
  const [wtsDatacheck, setWtsDtacheck] = useState(false)
  const [importPopUp, setImportPopUp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [Alerttxt, setAlerttxt] = useState("");
  const [Error2, setError2] = useState("")
  const [importedData, setImportedData] = useState([]);
  const [importError, setImportError] = useState("");
  const today = new Date();
  const currentTime = new Date();
  const startOfToday = new Date(currentTime);
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date(currentTime);
  endOfToday.setHours(23, 59, 59, 999);

  const yesterday = new Date(currentTime);
  yesterday.setDate(currentTime.getDate() - 1);
  const startOfYesterday = new Date(yesterday);
  startOfYesterday.setHours(0, 0, 0, 0);

  const endOfYesterday = new Date(yesterday);
  endOfYesterday.setHours(23, 59, 59, 999);

  const startOfWeek = new Date(currentTime);
  startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
  startOfWeek.setHours(12, 0, 0, 0);
  const endOfWeek = new Date(currentTime);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setHours(12, 0, 0, 0);

  const startOfMonth = new Date(currentTime);
  startOfMonth.setDate(1);
  startOfMonth.setHours(0, 0, 0, 0);

  const startOfYear = new Date(currentTime);
  startOfYear.setMonth(0, 1);
  startOfYear.setHours(0, 0, 0, 0);

  const endOfYear = new Date(currentTime);
  endOfYear.setMonth(11, 31);
  endOfYear.setHours(23, 59, 59, 999);

  today.setHours(23, 59, 0, 0);
  const [edateRange, setEDateRange] = useState([]);
  const [estartDate, eendDate] = edateRange;
  const [sdateRange, setSDateRange] = useState([]);
  const [sstartDate, sendDate] = sdateRange;
  const [cdateRange, setCDateRange] = useState([])
  const [cstartDate, cendDate] = cdateRange
  const [templateData, setTemplateData] = useState([]);
  const [selectedtemp, setSelectedtemp] = useState({
    templatename: "",
    template: "",
    id: ""
  })
  const [staticModal, setStaticModal] = useState(false);

  const toggleOpenNew = () => setStaticModal(!staticModal);
  const [mappings, setMappings] = useState({});
  const [errors, setErrors] = useState({});
  const [whatsappvar, setwhatsappvar] = useState([])
  const [customValues, setCustomValues] = useState({});
  const [alert, setAlert] = useState(false);
  const [pdfLink, setPdfLink] = useState(null);
  const [messagestatus, setMessagestatus] = useState({
    toggle: false,
    status: "",
    message: ""
  })
  const [segmentName, setSegmentName] = useState("")
  const [optSmModal, setOptSmModal] = useState(false)
  const [isNewSegment, setIsNewSegment] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState("");
  const [segments, setSegments] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const toggleModal = () => {
    setImportPopUp(true);
  }

  const popUpClose = () => {
    setErrorMessage("")
    setImportPopUp(false);
  }

  const importMembersExcelSheet = async (file) => {
    if (!file) {
      console.error("No file selected");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.onload = async () => {
      const buffer = reader.result;
      await workbook.xlsx.load(buffer);
      const worksheet = workbook.getWorksheet(1);

      const importedData = [];
      const validationErrors = [];

      const headers = {};
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (cell.value) {
          headers[cell.value] = colNumber;
        }
      });

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1 && row.hasValues) {
          let phoneNumber = headers["Phone Number"]
            ? row.getCell(headers["Phone Number"])?.value || ""
            : "";
          const createdAtValue = headers["Created On"]
            ? row.getCell(headers["Created On"])?.value || ""
            : "";

          let createdAtDate = new Date(createdAtValue);
          if (!isNaN(createdAtDate.getTime())) {
            const now = new Date();
            createdAtDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
          } else {
            createdAtDate = null;
          }

          const capitalizeFirstLetter = (str) => {
            if (!str) return "";
            str = str.toString().trim().toLowerCase();
            return str.charAt(0).toUpperCase() + str.slice(1);
          };

          const extractPlainValue = (value) => {
            if (!value) return "";
            if (typeof value === "object") {
              if (value.text) return value.text.toString().trim().toLowerCase();
              if (value.richText) {
                return value.richText.map(rt => rt.text).join("").trim().toLowerCase();
              }
              return JSON.stringify(value).trim().toLowerCase();
            }
            return value.toString().trim().toLowerCase();
          };

          const formattedPhone = formattedPhoneFunction(phoneNumber);

          const normalizeGender = (value) => {
            if (!value) return "";
            value = value.toString().trim().toLowerCase();
            if (["m", "male"].includes(value)) return "Male";
            if (["f", "female"].includes(value)) return "Female";
            return capitalizeFirstLetter(value);
          };

          const transformedRow = {
            fname: headers["First Name"]
              ? capitalizeFirstLetter(row.getCell(headers["First Name"])?.value) || ""
              : "",
            lname: headers["Last Name"]
              ? capitalizeFirstLetter(row.getCell(headers["Last Name"])?.value) || ""
              : "",
            number: formattedPhone,
            sex: headers["Gender"]
              ? normalizeGender(row.getCell(headers["Gender"])?.value) || ""
              : "",
            age: headers["Age"]
              ? row.getCell(headers["Age"])?.value || ""
              : "",
            height: headers["Height (cm)"]
              ? row.getCell(headers["Height (cm)"])?.value || null
              : null,
            weight: headers["Weight (kg)"]
              ? row.getCell(headers["Weight (kg)"])?.value || null
              : null,
            bloodgroup: headers["Blood Group"]
              ? capitalizeFirstLetter(row.getCell(headers["Blood Group"])?.value) || ""
              : "",
            email: headers["Email"]
              ? extractPlainValue(row.getCell(headers["Email"])?.value) || ""
              : "",
            city: headers["City"]
              ? row.getCell(headers["City"])?.value || ""
              : "",
            country: headers["Country"]
              ? row.getCell(headers["Country"])?.value || ""
              : "",
            address: headers["Address"]
              ? row.getCell(headers["Address"])?.value || ""
              : "",
            createdAt: createdAtDate ? createdAtDate.toISOString() : "",
          };

          const errors = validateRow(transformedRow, rowNumber);
          if (errors.length > 0) {
            validationErrors.push(...errors);
          } else {
            importedData.push(transformedRow);
          }
        }
      });

      setImportedData(importedData);

      let requestData = {
        gymId: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      };

      if (validationErrors.length > 0) {
        requestData.status = "failed";
        requestData.errors = validationErrors;
        setErrorMessage(validationErrors.join("\n"));
        setTimeout(() => {
          setImportPopUp(false);
          setErrorMessage("");
        }, 20000);
        await createImportedMember(requestData);
        return;
      }

      if (importedData.length === 0) {
        setImportError("The file is empty or does not contain valid data.");
        setImportPopUp(false);
        return;
      } else {
        setImportError("");
      }

      try {
        requestData.status = "success";
        requestData.data = importedData;

        const response = await createImportedMember(
          requestData,
          localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : ""
        );

        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        }
        else {
          const result = await response.json();
          if (result.message == "Success") {
            setAlerttxt("Member(s) Imported Sucessfully");
            await trackButtonClick("MManger", "Member_Import", "staff", {});
          } else {
            setError2("Failed to Import Member(s)");
          }
          setImportPopUp(false);
        }

      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const formattedPhoneFunction = (phone) => {
    if (!phone) return null;
    phone = phone.toString().trim();
    const onlyDigits = phone.replace(/[^\d+]/g, "");
    if (onlyDigits.startsWith("+")) {
      return onlyDigits;
    }
    if (onlyDigits.length === 10) {
      return "+91" + onlyDigits;
    }
    if (onlyDigits.length === 12 && onlyDigits.startsWith("91")) {
      return "+" + onlyDigits;
    }
    return null;
  };

  const validateRow = (row, rowNumber) => {
    const errors = [];

    if (!row.fname) errors.push(`Row ${rowNumber}: First Name is required.`);

    if (row.age && (isNaN(row.age) || row.age <= 0)) {
      errors.push(`Row ${rowNumber}: Age must be a positive number.`);
    }

    if (row.height && (isNaN(row.height) || row.height <= 0)) {
      errors.push(`Row ${rowNumber}: Height must be a positive number.`);
    }

    if (row.weight && (isNaN(row.weight) || row.weight <= 0)) {
      errors.push(`Row ${rowNumber}: Weight must be a positive number.`);
    }
    if (!row.createdAt) errors.push(`Row ${rowNumber}: Created Date is required. Please enter the Created Date in YY/MM/DD format.`);

    const validBloodGroups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
    if (row.bloodgroup && !validBloodGroups.includes(row.bloodgroup.toUpperCase())) {
      errors.push(`Row ${rowNumber}: Invalid Blood Group. Accepted values are: ${validBloodGroups.join(", ")}.`);
    }

    if (row.sex) {
      const normalizedGender = row.sex.trim().toLowerCase();
      if (!["male", "female"].includes(normalizedGender)) {
        errors.push(`Row ${rowNumber}: Gender must be either 'Male' or 'Female'.`);
      } else {
        row.sex = normalizedGender.charAt(0).toUpperCase() + normalizedGender.slice(1);
      }
    }
    return errors;
  };

  const handleSampleMembersDownload = () => {
    const sampleData = [
      {
        fname: "Sushant",
        lname: "V",
        email: "Sushant@gmail.com",
        number: "+918574961230",
        address: "1-9-7, Hitechcity",
        age: "30",
        bloodgroup: "B+",
        city: "Hyderabad",
        country: "India",
        sex: "Male",
        height: 180,
        weight: 75,
        createdAt: "YYYY/MM/DD"
      },
      {
        fname: "Jesmitha",
        lname: "K",
        email: "Jesmitha@gmail.com",
        number: "+919876543210",
        address: "1-9-8, Raidurg",
        age: "25",
        bloodgroup: "O+",
        city: "Hyderabad",
        country: "India",
        sex: "Female",
        height: 170,
        weight: 50,
        createdAt: "YYYY/MM/DD"
      },
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sample Member Data");

    worksheet.columns = [
      { header: "First Name", key: "fname", width: 15 },
      { header: "Last Name", key: "lname", width: 15 },
      { header: "Phone Number", key: "number", width: 15 },
      { header: "Gender", key: "sex", width: 10 },
      { header: "Age", key: "age", width: 10 },
      { header: "Height (cm)", key: "height", width: 15 },
      { header: "Weight (kg)", key: "weight", width: 15 },
      { header: "Blood Group", key: "bloodgroup", width: 10 },
      { header: "Email", key: "email", width: 25 },
      { header: "City", key: "city", width: 15 },
      { header: "Country", key: "country", width: 15 },
      { header: "Address", key: "address", width: 30 },
      { header: "Created On", key: "createdAt", width: 30 },
    ];

    sampleData.forEach((data) => {
      worksheet.addRow(data);
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Sample_Member_Data.xlsx";
      link.click();
    });
  };

  const WaiverSettingsOpen = async (e, data) => {
    e.stopPropagation();
    e.preventDefault();
    const resp = await getWaiver(data);
    if (!resp) {
      return;
    }

    if (resp == "false") {
      setAlert(true)
      return;
    }
    const waiver = await resp.json();
    console.log(waiver, "waiver")
    if (waiver.gymid) {
      setFormData(waiver);
    }
    if (waiver.pdffilelink) {
      setPdfLink(waiver.pdffilelink);
    }
    console.log(pdfLink);
    setWaiverPopup(true);
  }

  function onsubmit() {
    setFlag(1);
  }

  async function fetchTData() {
    try {
      setWtsDtacheck(true)
      const response = await getWhatsAppTEMP(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
      if (!response) {
        setWtsDtacheck(false);
        return;
      }
      if (response == "false") {
        setApiError(true);
        setWtsDtacheck(false);
        return;
      }

      const responseText = await response.text();
      if (!responseText) {
        throw new Error("Empty response from server.");
      }

      let TemplateData;
      try {
        TemplateData = JSON.parse(responseText);
      } catch (error) {
        console.error("Failed to parse JSON:", responseText);
        throw error;
      }

      console.log(TemplateData);

      // WATI API returns status "APPROVED"; Meta DB templates use "approved" (see whatsAppController transformDBTemplate)
      const filterTemplates = TemplateData.messageTemplates && TemplateData.messageTemplates.length > 0
        ? TemplateData.messageTemplates.filter((item) =>
          String(item.status || "").toUpperCase() === "APPROVED"
        )
        : [];
      console.log(filterTemplates);
      setWtsDtacheck(false)
      setTemplateData(filterTemplates);
    } catch (error) {
      console.error("Error fetching template data:", error);
      setWtsDtacheck(false);
    }
  }

  useEffect(() => {
    fetchTData();
  }, []);

  function createMemberCallback(e, newMember, flag, updates) {
    console.log(flag, "flag");
    setAlerttxt(flag);
    togglePopup();
    setFlag(prev => prev + 1);
  }

  async function deleteThisMember(e, tmemberId) {
    e.stopPropagation();
    let ip = localStorage.getItem("ipaddress");
    let browserinfo = browserName + "-" + browserVersion + ".0.0";
    let flag = `Member Deleted Successfull (${tmemberId.fname} ${tmemberId.lname})`;
    let Eventtype = "member";
    let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
    if (window.confirm("Are you sure want to delete this Member?")) {
      deleteMember(tmemberId._id);
      await trackButtonClick("MManger", "Delete_Member", "staff", {});
      setAlerttxt("Member deleted successfully");
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
      logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
      setFlag(prev => prev + 1);
    }
  }

  function openAddform(e) {
    setMId(0);
    setaddandSave(1);
    togglePopup();
  }

  function openEditForm(e, tId) {
    e.stopPropagation();
    setMId(tId.id);
    togglePopup();
  }

  const navigate = useNavigate();
  let location = useLocation();
  let clearDashboardFilters = 0;
  let clearFilterObject = {
    tidName: mfilter.tidName,
    planNme: mfilter.planNme,
    gender: mfilter.gender,
    status: mfilter.status,
    Ttype: mfilter.Ttype,
    inputText: mfilter.inputText,
    mType: mfilter.mType,
    transtype: mfilter.transtype,
    planType: mfilter.planType,
    fage: age.fage,
    tage: age.tage,
    estartDate: estartDate ? estartDate : "",
    eendDate: eendDate ? eendDate : "",
    sstartDate: sstartDate ? sstartDate : "",
    sendDate: sendDate ? sendDate : "",
    cstartDate: cstartDate ? cstartDate : "",
    cendDate: cendDate ? cendDate : "",
  };

  async function fetchPAData() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getGymPlansList(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }

      if (response === "false") {
        setApiError(true)
        return
      }

      const allplan = await response.json();
      let expandedPlans = [];

      allplan.forEach(plan => {
        plan.type = "plan";
        expandedPlans.push(plan);

        if (plan.subplans && plan.subplans.length > 0) {
          plan.subplans.forEach(sub => {
            sub.type = "plan";
            expandedPlans.push(sub);
          });
        }
      });

      const respo = await getGymAddonsList(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!respo) {
        return;
      }
      if (respo === "false") {
        setApiError(true)
        return;
      }
      const allAddons = await respo.json()
      allAddons.length > 0 && allAddons.forEach(plan => {
        plan.type = "addon";
      });

      let allData = expandedPlans.concat(allAddons);
      setPadata(allData)
    }
  }

  async function fetchData(sTxt) {
    if (localStorage.getItem("loggedUserInfo")) {
      let search = ""
      if (sTxt) {
        search = sTxt;
      }
      setMfilter({
        ...clearFilterObject,
        inputText: search
      })

      let locfilter = localStorage.getItem("memberm_filter");
      location.filter = {};

      if (locfilter) {
        let mlocfilter = JSON.parse(locfilter).filters;

        console.log("mlocfilter", mlocfilter);

        if ((mlocfilter && (mlocfilter.planNme.length > 0 ||
          mlocfilter.inputText !== "" ||
          mlocfilter.Ttype !== "" ||
          mlocfilter.tidName !== "" ||
          mlocfilter.gender !== "" ||
          mlocfilter.status !== "" ||
          mlocfilter.mType !== "" ||
          mlocfilter.planType !== "" ||
          mlocfilter.transtype !== "" ||
          mlocfilter.estartDate !== "" ||
          mlocfilter.sstartDate !== "" ||
          mlocfilter.cstartDate !== "" ||
          mlocfilter.eendDate !== "" ||
          mlocfilter.sendDate !== "" ||
          mlocfilter.cendDate !== "" ||
          mlocfilter.fage !== "" ||
          mlocfilter.tage !== ""))
        ) {
          setFilterr(true);
          setCheckFilter(true)
          setMfilter({
            tidName: mlocfilter.tidName,
            planNme: mlocfilter.planNme,
            gender: mlocfilter.gender,
            status: mlocfilter.status,
            Ttype: mlocfilter.Ttype,
            inputText: mlocfilter.inputText,
            mType: mlocfilter.mType,
            transtype: mlocfilter.transtype,
            planType: mlocfilter.planType
          })
          setSelectValue(mlocfilter?.planNme)

          console.log("0000000000000000");
          setEDateRange([mlocfilter.estartDate !== "" ? new Date(mlocfilter.estartDate) : null, mlocfilter.eendDate !== "" ? new Date(mlocfilter.eendDate) : null])
          setSDateRange([mlocfilter.sstartDate !== "" ? new Date(mlocfilter.sstartDate) : null, mlocfilter.sendDate !== "" ? new Date(mlocfilter.sendDate) : null])
          setCDateRange([mlocfilter.cstartDate !== "" ? new Date(mlocfilter.cstartDate) : null, mlocfilter.cendDate !== "" ? new Date(mlocfilter.cendDate) : null])
          setAge({
            fage: mlocfilter.fage,
            tage: mlocfilter.tage
          })
        }
        location.state = {}
        location.state.data = JSON.parse(locfilter).dashboardFID;
        location.state.fdate = JSON.parse(locfilter).dashboardFfdate;
        location.state.tdate = JSON.parse(locfilter).dashboardFtdate;
        location.filter = JSON.parse(locfilter).filters;
        localStorage.removeItem("memberm_filter");
      }
      location.limitmember = itemsPerPage;
      if (currentPage > totalPages) {
        setCurrentPage(1)
      }
      location.currentPage = currentPage > totalPages ? 1 : currentPage;
      console.log(location);
      if (location.state === null && valuee !== -1) {
        location.state = {}
        location.state.data = valuee;
        location.state.fdate = Date11;
        location.state.tdate = Date22;
      }
      if (clearDashboardFilters === 1) {
        location.state = {}
      }
      location.filter.planNme = clearFilterObject.planNme.length > 0 ? clearFilterObject.planNme : location.filter && (location.filter.planNme ? location.filter.planNme : []);
      location.filter.inputText = search !== "" ? search : location.filter && (location.filter.inputText ? location.filter.inputText : "");
      location.filter.Ttype = clearFilterObject.Ttype !== "" ? clearFilterObject.Ttype : location.filter && (location.filter.Ttype ? location.filter.Ttype : "");
      location.filter.tidName = clearFilterObject.tidName !== "" ? clearFilterObject.tidName : location.filter && (location.filter.tidName ? location.filter.tidName : "")
      location.filter.gender = clearFilterObject.gender !== "" ? clearFilterObject.gender : location.filter && (location.filter.gender ? location.filter.gender : "")
      location.filter.status = clearFilterObject.status !== "" ? clearFilterObject.status : location.filter && (location.filter.status ? location.filter.status : "")
      location.filter.mType = clearFilterObject.mType !== "" ? clearFilterObject.mType : location.filter && (location.filter.mType ? location.filter.mType : "")
      location.filter.planType = clearFilterObject.planType !== "" ? clearFilterObject.planType : location.filter && (location.filter.planType ? location.filter.planType : "")

      console.log(location.filter);

      const transdata = clearFilterObject.transtype !== "" ? clearFilterObject.transtype : location.filter && (location.filter.transtype ? location.filter.transtype : "")
      location.filter.transtype = transdata
      let estartOfDate = clearFilterObject.estartDate !== "" ? new Date(clearFilterObject.estartDate) : location.filter && (location.filter.estartDate ? new Date(location.filter.estartDate) : "")
      let eendOfDate = clearFilterObject.eendDate !== "" ? new Date(clearFilterObject.eendDate) : location.filter && (location.filter.eendDate ? new Date(location.filter.eendDate) : "")
      let sstartOfDate = clearFilterObject.sstartDate !== "" ? new Date(clearFilterObject.sstartDate) : location.filter && (location.filter.sstartDate ? new Date(location.filter.sstartDate) : "")
      let sendOfDate = clearFilterObject.sendDate !== "" ? new Date(clearFilterObject.sendDate) : location.filter && (location.filter.sendDate ? new Date(location.filter.sendDate) : "")
      let cstartOfDate = clearFilterObject.cstartDate !== "" ? new Date(clearFilterObject.cstartDate) : location.filter && (location.filter.cstartDate ? new Date(location.filter.cstartDate) : "")
      let cendOfDate = clearFilterObject.cendDate !== "" ? new Date(clearFilterObject.cendDate) : location.filter && (location.filter.cendDate ? new Date(location.filter.cendDate) : "")

      console.log(location.filter.transtype);
      console.log(estartOfDate, eendOfDate, sstartOfDate, sendOfDate, cstartOfDate, cendOfDate, '8888888866666666666444444444');

      if ((estartOfDate !== "" && eendOfDate !== "")) {
        const date = dateConverttoUtc(estartOfDate, eendOfDate)
        location.filter.estartDate = date.sdate;
        location.filter.eendDate = date.edate;
      }
      if ((sstartOfDate !== "" && sendOfDate !== "")) {
        const date = dateConverttoUtc(sstartOfDate, sendOfDate)
        location.filter.sstartDate = date.sdate;
        location.filter.sendDate = date.edate;
      }
      if ((cstartOfDate !== "" && cendOfDate !== "")) {
        const date = dateConverttoUtc(cstartOfDate, cendOfDate)
        location.filter.cstartDate = date.sdate;
        location.filter.cendDate = date.edate;
      }

      location.filter.fage = clearFilterObject.fage !== "" ? clearFilterObject.fage : location.filter && (location.filter.fage ? location.filter.fage : "");
      location.filter.tage = clearFilterObject.tage !== "" ? clearFilterObject.tage : location.filter && (location.filter.tage ? location.filter.tage : "");

      const response = await membertable(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
        location
      )

      if (!response) {
        return;
      }

      if (response === "false") {
        setApiError(true)
        return
      }
      let membersData = await response.json();

      console.log("membersData", membersData)
      if (!membersData) {
        navigate("/");
        return;
      }
      // Check if response has new structure (MemberView response)
      if (membersData.success !== undefined) {
        // New MemberView structure
        if (membersData.success === false) {
          console.error("API error:", membersData.error);
          return;
        }
        setTotalcount(membersData.totalCount || 0)
        setData(membersData.members || membersData.paginatedMembers || []);
        setTotalPages(membersData.totalPages || 1)
      } else {
        // Old structure for backward compatibility
        setTotalcount(membersData.totalCount || 0)
        setData(membersData.paginatedMembers || []);
        setTotalPages(membersData.totalPages || 1)
      }

      setValuee(location && location.state && location.state.data);
      setDate11(location && location.state && location.state.fdate);
      setDate22(location && location.state && location.state.tdate);
      setLoading(false);
    }
  }

  const dateConverttoUtc = (startDate, endDate) => {
    const startDatef = new Date(startDate)
    startDatef.setHours(0, 0, 0, 0)
    const utcstartDate = startDatef.toISOString();

    let lastoftheday = new Date(endDate);
    lastoftheday.setHours(23, 59, 59, 999);
    const utcEndDate = lastoftheday.toISOString();

    return { sdate: utcstartDate, edate: utcEndDate }
  }

  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const handleDashboardClearFilter = (e) => {
    e.preventDefault();
    setValuee(-1);
    setDate11(new Date());
    setDate22(new Date());
    clearDashboardFilters = 1;
    fetchData();
  }

  useEffect(() => {
    fetchData();
  }, [sFlag, currentPage, itemsPerPage, importPopUp]);

  function showThisInf(e, data) {
    const memberId = data[13]; // Get memberId from row data
    let selMember = memberData.filter(
      (tmdata) =>
        tmdata.fname + " " + tmdata.lname === data[1] && tmdata.mid === data[0]
    )[0];

    if (!selMember) return;

    // Ensure we have the correct ID for backward compatibility
    selMember._id = selMember.memberId || selMember._id;

    selMember.anotherColumn = valuee && valuee;
    selMember.Date11 = Date11;
    selMember.Date22 = Date22;
    selMember.return = "mmanager"
    selMember.filters = {
      planNme: mfilter.planNme,
      gender: mfilter.gender,
      Ttype: mfilter.Ttype,
      tidName: mfilter.tidName,
      status: mfilter.status,
      mType: mfilter.mType,
      planType: mfilter.planType,
      transtype: mfilter.transtype,
      estartDate: estartDate ? estartDate : "",
      eendDate: eendDate ? eendDate : "",
      sstartDate: sstartDate ? sstartDate : "",
      sendDate: sendDate ? sendDate : "",
      cstartDate: cstartDate ? cstartDate : "",
      cendDate: cendDate ? cendDate : "",
      fage: age.fage,
      tage: age.tage,
    }

    navigate("/mdetails", {
      state: selMember,
    });
  }

  function preaddUser(dataObj) {
    localStorage.setItem("preadd_plan", JSON.stringify(dataObj));
    localStorage.setItem("preadd_member", JSON.stringify(dataObj));
    localStorage.setItem("showPrevTransPopup", "true");
    navigate("/home");
  }

  // Helper functions
  const getValidityText = (validityflag, numberofdays) => {
    if (validityflag === 1) return numberofdays > 1 ? "Day(s)" : "Day";
    if (validityflag === 2) return numberofdays > 1 ? "Month(s)" : "Month";
    return numberofdays > 1 ? "Year(s)" : "Year";
  };

  const getAddonValidityText = (rentbasis) => {
    switch (rentbasis) {
      case "0": return "Hourly";
      case "1": return "1 Day(s)";
      case "2": return "1 Month";
      default: return "1 Year";
    }
  };

  const getPlanName = (data) => {
    if (data.planid) {
      // Convert to string for comparison (in case planid is ObjectId)
      const planidStr = data.planid.toString();

      // Search in plans array
      const plan = data.plans?.find(p => {
        const planIdStr = p.id?.toString();
        return planIdStr === planidStr;
      });
      if (plan) return plan.name || "Plan";

      // Search in addons array
      const addon = data.addons?.find(a => {
        const addonIdStr = a.id?.toString();
        return addonIdStr === planidStr;
      });
      if (addon) return addon.name || "Addon";
    }

    // Fallback
    if (data.plans?.length > 0) return data.plans[0].name || "Plan";
    if (data.addons?.length > 0) return data.addons[0].name || "Addon";

    return "No Plan Associated";
  };

  let tmrow = [];
  memberData.length > 0 && memberData.forEach((data, index) => {
    // Get memberId (from MemberView) or _id (from old Member)
    const memberId = data.memberId || data._id;

    // Check for plans and addons in MemberView format
    const hasPlans = data.plans && data.plans.length > 0;
    const hasAddons = data.addons && data.addons.length > 0;
    if (hasPlans) {
      const currentPlan = data.plans.find(plan =>
        plan.id && data.planid && plan.id.toString() === data.planid.toString()
      );
    }

    let rarray = [];
    rarray.push(data.mid);
    rarray.push(data.fname + " " + data.lname);
    rarray.push(data.number ? data.number : "--");
    rarray.push(data.sex ? data.sex : "--");
    rarray.push(data.age ? data.age : '--');

    rarray.push(getPlanName(data));

    // Start date
    rarray.push(
      hasPlans || hasAddons
        ? formatDate(data.startdate || (hasPlans ? data.plans[0]?.startdate : data.addons[0]?.startdate))
        : "No Plan Associated"
    );

    // Expiry date
    rarray.push(
      hasPlans || hasAddons
        ? formatDate(data.expirydate || (hasPlans ? data.plans[0]?.expirydate : data.addons[0]?.expirydate))
        : "No Plan Associated"
    );

    // Status
    rarray.push(<div className="title">
      {!data.issuspend ?
        data.membershipstatus ?
          data.membershipstatus :
          ((new Date(data.expirydate) < new Date()) ? "Inactive" : "Active")
        : "suspend"
      }
    </div>);

    // Transaction type
    rarray.push(
      hasPlans || hasAddons
        ? (data.transactiontype !== 0 ? "Renewed" : "New")
        : "--"
    );

    // Member created date - use memberCreatedAt from MemberView
    rarray.push(formatDate(data.memberCreatedAt || data.createdAt));

    // // Plan validity
    // if (hasPlans) {
    //   const latestPlan = [...data.plans].sort((a, b) =>
    //     new Date(b.createdAt) - new Date(a.createdAt)
    //   )[0];
    //   rarray.push(latestPlan.numberofdays
    //     ? `${latestPlan.numberofdays} ${getValidityText(latestPlan.validityflag, latestPlan.numberofdays)}`
    //     : "--");
    // } else if (hasAddons) {
    //   const latestAddon = [...data.addons].sort((a, b) =>
    //     new Date(b.createdAt) - new Date(a.createdAt)
    //   )[0];
    //   rarray.push(getAddonValidityText(latestAddon.rentbasis));
    // } else {
    //   rarray.push("No Plan Associated");
    // }

    // DND
    rarray.push(data.isDND ? "On" : "Off");

    // Waiver Form
    rarray.push(data.iswaiververified === true ?
      <div className="d-flex align-items-center">
        <div className="link-color me-2" style={{ zIndex: 2 }} onClick={(e) => WaiverSettingsOpen(e, memberId)}>
          Submitted
        </div>
      </div>
      : "Not Submitted"
    );

    // Actions - Renew
    const getLatestMembership = () => {
      if (hasPlans) {
        return [...data.plans].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )[0];
      }

      if (hasAddons) {
        return [...data.addons].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )[0];
      }

      return null;
    };

    const membership = getLatestMembership();

    rarray.push(
      <div className="d-flex align-items-center" style={{ gap: "10px", zIndex: 999 }}>



        {/* Edit */}
        {!data.issuspend ? (
          <img
            src={editImg}
            width="20px"
            alt="Edit"
            style={{ cursor: "pointer" }}
            onClick={(e) => openEditForm(e, { id: memberId })}
          />
        ) : (
          <img
            src={editImg}
            width="20px"
            alt="Edit"
            style={{ visibility: "hidden" }}
          />
        )}

        {/* Delete */}
        <img
          src={deleteImg}
          width="15px"
          alt="Delete"
          style={{ cursor: "pointer" }}
          onClick={(e) => deleteThisMember(e, { ...data, _id: memberId })}
        />
        {/* Renew */}
        {!data.issuspend && (hasPlans || hasAddons) && (
          <span
            className="link-color"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              preaddUser({
                member: data,
                planId: membership?.id,
                memberId: memberId,
              });
            }}
          >
            Renew
          </span>
        )}
      </div>
    );

    // Store memberId for use in click handler
    // rarray.push(memberId);

    tmrow.push(rarray);
  });

  const basicData = {
    columns: [
      "Member Id",
      "Name",
      "Contact",
      "Gender",
      "Age",
      "Plan/Addon",
      "Start Date",
      "Expiry Date",
      "Status",
      "Transaction Type",
      "Member Created",
      // "Plan Validity",
      "DND",
      "Waiver Form",
      "Actions",
      // "",
    ],
    rows: tmrow,
  };

  const downloaddata = async (e) => {
    fetchDataAndExport();
  }

  const formatPhone = (phone) => {
    let formatted = null;
    try {
      if (phone.startsWith('+')) {
        formatted = phone.replace('+', '');
      } else if (phone.startsWith('1')) {
        formatted = phone;
      } else if (phone.length < 10) {
        formatted = null;
      } else if (phone.length === 12) {
        formatted = phone;
      } else if (phone.length === 10) {
        formatted = '91' + phone;
      } else {
        formatted = phone;
      }
    } finally {
      return formatted;
    }
  };

  const fetchDataAndExport = async () => {
    location.limitmember = totalCount;
    location.currentPage = 1;
    const response = await membertable(
      localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      location
    );

    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
      return;
    }

    const memberData = await response.json();
    console.log(memberData, '1233456777');

    // Handle both response structures
    const members = memberData.members || memberData.paginatedMembers || [];

    let tmrow = [];
    members.length > 0 && members.forEach((data, index) => {
      const formattedPhone = formatPhone(data.number);
      let rarray = [];

      rarray.push(data.mid);
      rarray.push(data.fname + " " + data.lname);
      rarray.push(data.email);
      rarray.push(formattedPhone);
      rarray.push(data.sex);
      rarray.push(data.age);

      // Plan/Addon display for export
      const hasPlans = data.plans && data.plans.length > 0;
      const hasAddons = data.addons && data.addons.length > 0;

      if (hasPlans) {
        const latestPlan = [...data.plans].sort((a, b) =>
          new Date(b.createdAt) - new Date(a.createdAt)
        )[0];
        rarray.push(latestPlan.name || "Plan");
      } else if (hasAddons) {
        const latestAddon = [...data.addons].sort((a, b) =>
          new Date(b.createdAt) - new Date(a.createdAt)
        )[0];
        rarray.push(latestAddon.name || "Addon");
      } else {
        rarray.push("No Plan Associated");
      }

      rarray.push(formatDate(data.startdate));
      rarray.push(formatDate(data.expirydate));
      rarray.push(!data.issuspend ? ((new Date(data.expirydate) < new Date()) ? "Inactive" : "Active") : "suspend");
      rarray.push((hasPlans || hasAddons) ? (data.transactiontype !== 0 ? "Renewed" : "New") : "--");
      rarray.push(formatDate(data.memberCreatedAt || data.createdAt));

      if (hasPlans) {
        const latestPlan = [...data.plans].sort((a, b) =>
          new Date(b.createdAt) - new Date(a.createdAt)
        )[0];
        rarray.push(latestPlan.numberofdays
          ? `${latestPlan.numberofdays} ${getValidityText(latestPlan.validityflag, latestPlan.numberofdays)}`
          : "");
      } else if (hasAddons) {
        const latestAddon = [...data.addons].sort((a, b) =>
          new Date(b.createdAt) - new Date(a.createdAt)
        )[0];
        rarray.push(getAddonValidityText(latestAddon.rentbasis));
      } else {
        rarray.push("");
      }

      rarray.push(data.iswaiververified === true ? "Submitted" : "Not Submitted");
      rarray.push((data.address ? data.address : "") + (data.city && data.city !== "" ? (data.address ? `, ${data.city}` : data.city) : ""));

      tmrow.push(rarray);
    });

    const updatedBasicData = {
      columns: [
        "Member Id",
        "Name",
        "Email",
        "Contact",
        "Gender",
        "Age",
        "Plan/Addon",
        "StartDate",
        "ExpiryDate",
        "Status",
        "Transaction Type",
        "Member Created",
        "Plan Validity",
        "Waiver Form",
        "Address"
      ],
      rows: tmrow.length > 0 && tmrow,
    };

    ExcelExportButton(updatedBasicData, "MemberTableData");
    await trackButtonClick("MManger", "Member_Export", "staff", {});
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
    setLoading(true);
  };

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
    setLoading(true);
  };

  const handleApplyAndToggle = async () => {
    setCurrentPage(1)
    setCheckFilter(true)
    setFilterr(true)
    setLoading(true);
    fetchData();
  }

  const handleClearFilter = (filterKey) => {
    clearFilterObject = { ...clearFilterObject, [filterKey]: "", }
    setMfilter((prevMfilter) => ({
      ...prevMfilter,
      [filterKey]: "",
    }));
    fetchData()
  };

  const handleResetAndToggle = () => {
    setEDateRange([])
    setSDateRange([])
    setCDateRange([])
    setSelectValue([])
    setCurrentPage(1)
    clearFilterObject = {
      tidName: "",
      planNme: [],
      gender: "",
      status: "",
      Ttype: "",
      mType: "",
      planType: "",
      transtype: '',
      fage: '',
      tage: '',
      estartDate: "",
      eendDate: "",
      sstartDate: "",
      sendDate: "",
      cstartDate: "",
      cendDate: "",
    }
    setMfilter({
      tidName: "",
      planNme: [],
      gender: "",
      status: "",
      Ttype: "",
      mType: "",
      transtype: '',
      planType: "",
    });
    setAge({
      fage: '',
      tage: ''
    })
    clearDashboardFilters = 1
    console.log(location);
    fetchData()
    setFilterr((prevFilterr) => !prevFilterr);
  }

  const filterLabels = {
    planNme: "Plan/Addon",
    tidName: "Search by Member / Contact",
    gender: "Gender",
    status: "Status",
    Ttype: "Transaction Type",
    mType: "Membership Type",
    transtype: "Transition Type",
    planType: "Plan Type"
  };

  useEffect(() => {
    fetchPAData()
  }, [])

  useEffect(() => {
    if (!padata || padata.length === 0) return;
    const planMap = new Map();

    padata.forEach(plan => {
      if (!plan._id) return;

      const labelType = plan.type === "addon" ? "Addon" : "Plan";
      let baseName = plan.name;

      if (plan?.baseplan) {
        const baseplanName = BasePlanName(padata, plan?.baseplan);
        baseName = `${baseplanName} - ${plan.name}`;
      }

      const displayName = plan.archived
        ? `${baseName} – Inactive`
        : baseName;

      planMap.set(plan._id, {
        text: `${displayName} (${labelType})`,
        value: plan._id,
        name: baseName,
        rawName: plan.name
      });
    });

    const formattedItems = Array.from(planMap.values());
    formattedItems.unshift({
      text: "No Plan(s) & No addon(s)",
      value: "Noplan",
      name: "Noplan",
      rawName: "Noplan"
    });

    setSelectData(formattedItems);
  }, [padata]);

  const CalenderInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <span className="form-control select-input  placeholder-active me-3 shadow-1 d-flex align-items-center justify-content-between" onClick={onClick}>
        <p className="d-inline m-0 me-2">
          {value === "" ? "Custom Range" : value}
        </p>
        <img src={calImg} alt="Custom Range" ref={ref} title="Select Custom Range" />
      </span>
    </>
  ));

  const handleReload = () => {
    window.location.reload();
  }

  const [appVariables, setAppvariables] = useState([])
  useEffect(() => {
    fetchSMSData()
  }, []);

  async function fetchSMSData() {
    const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null
    const res = await getappvariables(gymid)
    console.log(res, "inside apivarible");

    if (!res) {
      return
    }
    if (res === "false") {
      setApiError(true)
      return
    }
    const variables = await res.json();
    console.log(variables, '8888888888888888');
    if (variables.length > 0) {
      setAppvariables(variables)
    }
  }

  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);
  const [ids, setIds] = useState([])

  const whatsappHandler = async () => {
    location.limitmember = totalCount;
    location.currentPage = 1;
    const response = await membertable(
      localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      location
    );
    if (!response) {
      return
    }
    if (response == "false") {
      setApiError(true)
      return
    }
    const membersData = await response.json();

    // Handle both response structures
    const members = membersData.members || membersData.paginatedMembers || [];

    const uniqueNumbers = new Set();
    const numbers = members.length > 0 && members
      .filter(entry => !entry.isDND)
      .map(entry => {
        const memberId = entry.memberId || entry._id;
        const { number, fname, lname } = entry;
        const formattedNumber = formatPhone(number);
        return formattedNumber ? { _id: memberId, number, fname, lname } : null;
      })
      .filter(entry => {
        if (!entry || uniqueNumbers.has(entry.number)) {
          return false;
        }
        uniqueNumbers.add(entry.number);
        return true;
      });

    const jsonData = JSON.stringify(numbers);
    const dataSize = new Blob([jsonData]).size;
    const sizeInKB = dataSize / 1024;
    console.log(`Data size: ${dataSize} bytes (${sizeInKB.toFixed(2)} KB)`);

    const ids = numbers.map(item => ({ _id: item._id }));
    setIds(ids);
    setNumberData(numbers)
    toggleOpen();
  }

  const [errr, seterrr] = useState("")
  const [templateinfo, setTemplateinfo] = useState(null)

  const handleSendmessage = async () => {
    if (campainName != "") {
      if (templateinfo && templateinfo.customParams && templateinfo.customParams.length > 0) {
        toggleOpenNew()
      } else {
        setAlert(true)
      }
    } else {
      seterrr("This can't be blank")
    }
  }

  const handleTemplateSelection = (item) => {
    setTemplateinfo(item)
    if (selectedtemp && selectedtemp.templatename === item.elementName) {
      setSelectedtemp(null);
    } else {
      setSelectedtemp({
        templatename: item.elementName,
        template: item.bodyOriginal ? item.bodyOriginal : item.body,
        id: item.id
      });
    }
  };

  const filteredTemplates = templateData.length > 0 && templateData.filter(item =>
    item.elementName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectChange = (waitVar, event) => {
    const selectedValue = event.target.value;
    setMappings(prevMappings => ({
      ...prevMappings,
      [waitVar]: selectedValue
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [waitVar]: null
    }));

    if (selectedValue !== "customvalue") {
      setCustomValues(prevCustomValues => ({
        ...prevCustomValues,
        [waitVar]: ''
      }));
    }
  };

  useEffect(() => {
    if (templateinfo && templateinfo.customParams) {
      const waitVariables = templateinfo.customParams.map(param => param.paramName);
      setwhatsappvar(waitVariables);
    }
  }, [templateinfo]);

  const handleCustomValueChange = (waitVar, event) => {
    const customValue = event.target.value;
    setCustomValues(prevCustomValues => ({
      ...prevCustomValues,
      [waitVar]: customValue
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [waitVar]: customValue === "" ? "This can't be blank." : null
    }));
  };

  const [mappingdata, setMappingdata] = useState(null)

  const handleSubmit = async () => {
    const newErrors = {};
    whatsappvar.forEach(varName => {
      if (!mappings[varName] || mappings[varName] === "Select") {
        newErrors[varName] = "Mandatory field";
      }
      if (mappings[varName] === "customvalue" && !customValues[varName]) {
        newErrors[varName] = "Mandatory field";
      }
    });

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      const formattedMappings = whatsappvar.map(varName => ({
        wativariable: varName,
        [mappings[varName] === "customvalue" ? "customvalue" : "applicationvariable"]: mappings[varName] === "customvalue" ? customValues[varName] : mappings[varName]
      }));
      console.log("Formatted Mappings:", formattedMappings);
      setMappingdata(formattedMappings)
      setAlert(true)
    }
  };

  const handlealert = async () => {
    const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null
    if (templateinfo.customParams.length > 0) {
      const res = await sendWhatsappmessage(gymid, { memberData: ids, message: selectedtemp, variables: mappingdata, campainName: campainName })
      if (!res) {
        return;
      }
      if (res === "false") {
        setApiError(true)
        return
      }
      const result = await res.json();
      console.log(result, '777777777777');
      setMessagestatus({
        toggle: true,
        status: result.status,
        message: result.message
      })
      await trackButtonClick("MManger", "WhatsApp_Campaign", "staff", {});
      toggleOpenNew()
      toggleOpen();
      setSelectedtemp(null)
      setTemplateinfo([])
      setCustomValues({})
      setMappings({})
      setSearchTerm("")
      setCampainName("")
      setAlert(false)
    } else {
      const res = await sendWhatsappmessage(gymid, { memberData: ids, message: selectedtemp, campainName: campainName })
      if (!res) {
        return;
      }
      if (res === "false") {
        setApiError(true)
        return
      }
      const result = await res.json();
      console.log(result, '77777777777');
      setMessagestatus({
        toggle: true,
        status: result.status,
        message: result.message
      })
      await trackButtonClick("MManger", "WhatsApp_Campaign", "staff", {});
      toggleOpen();
      setSelectedtemp(null)
      setAlert(false)
      setCampainName("")
    }
  }

  const cancelhandler = () => {
    setBasicModal(false)
    setCampainName("")
    seterrr("")
    setSelectedtemp(null)
  }

  const handleclose = () => {
    setStaticModal(false);
  }

  const createSegmentHandler = () => {
    setOptSmModal(true)
  }

  async function fetchSData() {
    const response = await getSegment(
      localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
    );
    if (!response) {
      return;
    }
    if (response === "false") {
    } else {
      const segments = await response.json();
      console.log(segments);
      setSegments(segments);
    }
  }

  useEffect(() => {
    fetchSData();
  }, []);

  const handleSegmentType = (e) => {
    const selectedValue = e.target.value;
    setToggle(selectedValue === 'fixed');
  };

  const handleSaveSegment = async () => {
    if (isNewSegment) {
      const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null
      const newfilter = {
        filter: location.filter,
        isfreeze: toggle
      }
      const update = {
        filters: [newfilter],
        name: segmentName,
        bid: gymid,
        _id: -1
      }
      const res = await createSegment(update, gymid)
    } else {
      const gymid = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        : null;

      const segmentInfo = segments && segments.length > 0
        ? segments.find((item) => item._id == selectedSegment)
        : {};

      console.log("Existing Segment Info:", location.filter, segmentInfo);
      const oldFilterArray = Array.isArray(segmentInfo.filters) ? segmentInfo.filters : [];
      console.log(oldFilterArray);

      const newfilter = {
        filter: location.filter,
        isfreeze: toggle,
        membersid: []
      }
      const newFilterArray = newfilter ? [newfilter] : [];

      const combinedFilter = [...oldFilterArray, ...newFilterArray];
      console.log(combinedFilter);

      const update = {
        filters: combinedFilter,
        bid: gymid,
        _id: segmentInfo._id
      };

      console.log("Updated Segment Data:", update);
      const res = await createSegment(update, gymid)
    }
  }

  const toggleSegmentClose = () => {
    setOptSmModal(false)
    setSegmentName("")
    setIsNewSegment(null)
  }

  useEffect(() => {
    fetchSData();
  }, []);

  // useEffect(() => {
  //   if (segments.length > 0) {
  //     setSelectedSegment(segments[0].id); // Set first segment as default
  //   }
  // }, [segments]);

  // const handleSegmentType = (e) => {
  //   const selectedValue = e.target.value;
  //   setToggle(selectedValue === 'fixed');
  // };

  console.log(toggle, 'toggle');
  console.log(toggle, 'toggle');

  const { handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("membersmanagement")

  return (
    <>
      <LeftPane isactive="3" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> :
        <div className="gym-main rightContent">
          <div className="gym-container" id="showcase">
            {roleAccess?.addmember == 1 && <div className="d-flex space-between align-center m-3">

              <h3 className="gym-large">Members Management</h3>
              <MDBBtn color="light"
                style={{ cursor: "pointer!important" }}
                id="adduserBtn"
                onClick={(e) => openAddform(e)}
              >
                <img src={addImg} alt="Add Member" width="16px" className="me-1" /> Add Member
              </MDBBtn>
            </div>}

            <div className="d-flex mob-inline-block align-items-center justify-content-start">
              {valuee !== -1 && valuee !== null && valuee !== undefined && (
                <MDBChip className=" mb-0">
                  {([0, 1, 2].includes(valuee) && "New Members") ||
                    ([10, 11, 12].includes(valuee) && "Active Members") ||
                    ([3, 4, 5].includes(valuee) && "Plan Exp") ||
                    ([6, 7, 8, 9].includes(valuee) && "Plan Renewals")}
                  <div className="d-flex align-items-center justify-content-center text-danger"
                    onClick={(e) => handleDashboardClearFilter(e)}
                    style={{ cursor: 'pointer' }}
                  >
                    <i className="fa fa-close ms-2"></i>
                  </div>
                </MDBChip>
              )}

              {filterr && checkFilter && Object.entries(mfilter).map(([key, value]) => (
                filterr && (
                  (typeof value === 'string' && value.trim() !== "") ||
                  (Array.isArray(value) && value.length > 0)
                ) && filterLabels[key] && (
                  <MDBChip key={key} closeIcon className="mb-0" onDelete={() => handleClearFilter(key)}>
                    {filterLabels[key]}
                  </MDBChip>
                )
              ))}
            </div>

            <div className="searchFilterToggle mt-2">
              <div className=" d-flex flex-wrap">
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile">
                  <label className="fw-bold">Search by Member/Contact/Member Id</label>
                  <div>
                    <input
                      type="text"
                      ref={searchRef}
                      value={mfilter.tidName}
                      className="form-control select-input placeholder-active form-controlMobile"
                      placeholder="search here..."
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        tidName: e.target.value.toLowerCase()
                      })}
                    />
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-300 w-100-mobile ms-2">
                  <label className="fw-bold">Plan/Addons</label>
                  <div>
                    {selectData.length > 0 ? (
                      <CustomMultiSelectDropdown
                        selectData={selectData}
                        value={selectValue}
                        onChange={(selectedIds) => {
                          setSelectValue(selectedIds);
                          setMfilter(prev => ({
                            ...prev,
                            planNme: selectedIds
                          }));
                        }}
                      />
                    ) : (
                      <div className="dropdown-error-option">
                        <span>No plans/addons available</span>
                      </div>
                    )}
                  </div>
                </div>}


                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">
                  <label className="fw-bold">Membership Type</label>
                  <div>
                    <select
                      name="emailReminder"
                      id="emailReminder"
                      className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                      value={mfilter.mType}
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        mType: e.target.value
                      })}
                    >
                      <option value="">All</option>
                      <option value="plans">Plans</option>
                      <option value="addons">Addons</option>
                      <option value="noplans">No plans/addons</option>
                    </select>
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">
                  <label className="fw-bold">Plan Type</label>
                  <div>
                    <select
                      name="emailReminder"
                      id="emailReminder"
                      className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                      value={mfilter.planType}
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        planType: e.target.value
                      })}
                    >
                      <option value="">All</option>
                      <option value="onetime">One-Time</option>
                      <option value="recurring">Recurring</option>
                    </select>
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">
                  <label className="fw-bold">Gender</label>
                  <div>
                    <select
                      name="emailReminder"
                      id="emailReminder"
                      className="form-control select-input placeholder-active form-select me-3 shadow-1 form-selectMobile"
                      value={mfilter.gender}
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        gender: e.target.value
                      })}
                    >
                      <option value="">All</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">
                  <label className="fw-bold">Status</label>
                  <div>
                    <select
                      name="emailReminder"
                      id="emailReminder"
                      className="form-control select-input placeholder-active form-select shadow-1 me-3 form-selectMobile"
                      value={mfilter.status}
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        status: e.target.value
                      })}
                    >
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">
                  <label className="fw-bold">Transaction Type</label>
                  <div>
                    <select
                      name="emailReminder"
                      id="emailReminder"
                      className="form-control select-input placeholder-active form-select shadow-1 form-selectMobile"
                      value={mfilter.Ttype}
                      onChange={(e) => setMfilter({
                        ...mfilter,
                        Ttype: e.target.value
                      })}
                    >
                      <option value="">All</option>
                      <option value="Renewed">Renewed</option>
                      <option value="New">New</option>
                    </select>
                  </div>
                </div>}




                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-3 align-self-end d-block">

                  <label className="fw-bold">Plan Expired Range</label>
                  <div>
                    <div className="w_200px w-100-mobile">
                      <div className="gym-xlarge gym-larg-pos">
                        <DatePicker
                          dateFormat={"d/M/yyyy"}
                          selectsRange={true}
                          startDate={estartDate}
                          endDate={eendDate}
                          onChange={(update) => {
                            setEDateRange(update)
                          }}
                          isClearable={false}
                          customInput={<CalenderInput />}
                        />
                      </div>
                    </div>
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">

                  <label className="fw-bold">Plan Start Range</label>
                  <div className="w_200px w-100-mobile">
                    <div className="gym-xlarge gym-larg-pos">
                      <DatePicker
                        dateFormat={"d/M/yyyy"}
                        selectsRange={true}
                        startDate={sstartDate}
                        endDate={sendDate}
                        onChange={(update) => {
                          setSDateRange(update)
                        }}
                        isClearable={false}
                        customInput={<CalenderInput />}
                      />
                    </div>
                  </div>
                </div>}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">

                  <label className="fw-bold">Member Create Range</label>
                  <div className="w_200px w-100-mobile">
                    <div className="gym-xlarge gym-larg-pos">
                      <DatePicker
                        dateFormat={"d/M/yyyy"}
                        selectsRange={true}
                        startDate={cstartDate}
                        endDate={cendDate}
                        onChange={(update) => {
                          setCDateRange(update)
                        }}
                        isClearable={false}
                        customInput={<CalenderInput />}
                      />
                    </div>
                  </div>
                </div>}

                {/* {mfilter.transtype !== "" && mfilter.transtype == "age" && */}
                {roleAccess?.search == 1 && <div className="gym-section w-100-mobile ms-2 align-self-end d-block">
                  <label className="fw-bold">Age Range</label>
                  <div className="d-flex align-items-center w-auto">
                    <input type="number" name="" id="" className="form-control w-80px" placeholder="From" value={age.fage}
                      onChange={(e) => setAge({
                        ...age,
                        fage: e.target.value
                      })} />
                    <div className="mx-2">-</div>
                    <input type="number" name="" id="" className="form-control w-80px " placeholder="To" value={age.tage}
                      onChange={(e) => setAge({
                        ...age,
                        tage: e.target.value
                      })} />
                  </div>
                </div>}

                <div className="gym-section w-100-mobile ms-3 align-self-end ">
                  <div className="mt-1 pt-1 filterApplyMobile ">
                    {roleAccess?.search == 1 && <button type="submit" className="me-2 btn btn-primary"
                      onClick={(e) => handleApplyAndToggle()}
                    >
                      Apply
                    </button>}
                    {roleAccess?.search == 1 && <button type="submit" className="mt-2 btn btn-secondary"
                      onClick={(e) => handleResetAndToggle()}
                    >
                      Clear
                    </button>}
                    {/* {(localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role == "admin" && <button type="submit" className="ms-2 btnheight btn btn-primary"
                    onClick={(e) => downloaddata()}
                  >
                    <MDBIcon fas icon="download" className="d-inline me-1" />Export
                  </button>} */}
                    {(localStorage.getItem("loggedUserInfo")) &&
                      <>
                        {roleAccess?.export == 1 && <button type="submit" className="ms-2 btnheight btn btn-primary" onClick={(e) => downloaddata()}>
                          <MDBIcon fas icon="download" className="d-inline me-1" />Export
                        </button>}

                        {roleAccess?.whatsapp == 1 && <MDBTooltip placement="bottom-end" tag='a' title={wtsDatacheck ? "Loading please wait" : (filteredTemplates && filteredTemplates.length > 0 ? "whatsApp" : `Complete the WhatsApp settings on the "Templates & Reminders" page to enable this feature.`)} >
                          <button type="submit" disabled={filteredTemplates && filteredTemplates.length > 0 ? false : true} className="ms-2 btnheight btn btn-primary whatsapp" onClick={(e) => whatsappHandler()}>
                            <i className="d-inline fs-6 me-1 fab fa-whatsapp" ></i>WhatsApp
                          </button>
                        </MDBTooltip>}
                        {/* <button type="submit" className="ms-2 btnheight btn btn-primary whatsapp" onClick={(e) => createSegmentHandler()}>
                          <i className="d-inline fs-6 me-1 fab fa-whatsapp" ></i>Segment
                        </button> */}

                        {roleAccess?.import == 1 && <button type="submit" className="ms-2 btnheight btn btn-primary" onClick={toggleModal}>
                          <MDBIcon fas icon="file-import" className="d-inline me-1" />Import
                        </button>}

                      </>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tableContainer">
            {loading ? (<h4><Loader /></h4>) :
              <div className="datatable cursorPointer mmManager_Table" data-mdb-fixed-header="true">
                <div className="mmtablediv">
                  <MDBTable hover small scroll>
                    <MDBTableHead>
                      <tr>
                        {basicData.columns.map((column, index) => (
                          <th key={index}>{column}</th>
                        ))}
                      </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                      {basicData.rows.map((row, rowIndex) => (
                        <tr key={rowIndex}
                          onClick={(e) => {
                            showThisInf(e, row);
                          }}
                        >
                          {row.map((cell, cellIndex) => (
                            <td key={cellIndex}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                      {basicData.rows.length === 0 && <tr >
                        <td colSpan={15}><p className=" d-flex justify-content-center"> No Data Found</p></td>
                      </tr>}
                    </MDBTableBody>
                  </MDBTable>
                </div>

                <div className="datatable-pagination">
                  Rows per page
                  <div className="ms-2 form-control w-auto">
                    <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} className="Pagenation-Select">
                      <option value="50">
                        <div className="select-option">
                          50
                        </div>
                      </option>
                      <option value="100">
                        <div className="select-option">
                          100
                        </div>
                      </option>
                      <option value="500">
                        <div className="select-option">
                          500
                        </div>
                      </option>
                      <option value="1000">
                        <div className="select-option">
                          1000
                        </div>
                      </option>
                    </select>
                  </div>
                  <button onClick={prevPage}
                    disabled={currentPage === 1}
                    className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark">
                    Previous
                  </button>
                  <div className="d-flex justify-content-between w-150px align-items-center"> Page
                    <input className="form-control w-50px" value={currentPage} onChange={(e) => setCurrentPage(Number(e.target.value))} />
                    of {totalPages}</div>
                  <button onClick={nextPage}
                    disabled={currentPage === totalPages}
                    className="btn btn-link datatable-pagination-button datatable-pagination-right ripple-surface-dark">
                    Next
                  </button>
                </div>
              </div>}
          </div>
        </div >}

      {isOpen && (
        <Popup
          title="Add Member"
          ptype="modal-lg"
          className="modal-body-overflow"
          content={
            <>
              <div className="modal-body-overflow">
                <CreateMember
                  id={null}
                  index={null}
                  onsubmit={onsubmit}
                  backallback={createMemberCallback}
                  submit="0"
                  mId={mId}
                  addandSave={addandSave}
                  from={"reload"}
                  path={"membership"}
                  gymid={JSON.parse(localStorage.getItem("loggedUserInfo")).gymid}
                />
              </div>
            </>
          }
          handleClose={togglePopup}
        />
      )}

      {WaiverPopup &&
        <MDBModal open={WaiverPopup} setOpen={setWaiverPopup} tabIndex='-1'>
          <MDBModalDialog size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Digital Waiver Form</MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={() => { setWaiverPopup(false); setFormData({}); setPdfLink(null); }}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                {pdfLink ? (
                  <iframe
                    src={`${pdfLink}#toolbar=0&navpanes=0`}
                    title="Waiver PDF"
                    width="100%"
                    height="700px"
                    style={{ border: 'none', overflow: 'hidden', display: 'block' }}
                  />
                ) : formData.gymid ? (
                  <VeiwWaiverForm data={formData} />
                ) : (
                  <Loader />
                )}
              </MDBModalBody>
              <MDBModalFooter className="pb-2 pe-3">
                <MDBBtn color='secondary' onClick={() => { setWaiverPopup(false); setFormData({}); setPdfLink(null) }}>
                  Close
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      }

      <MDBModal open={basicModal} onClose={() => cancelhandler()} tabIndex='-1'>
        <MDBModalDialog size="xl">
          <MDBModalContent>
            <MDBModalHeader className="w-100 flex-wrap">
              <MDBModalTitle className="w-sm-100">
                <div className="w-sm-100">
                  <div className="">WhatsApp Templates</div>
                </div>
              </MDBModalTitle>
              <div className="d-flex justify-content-end w-100 align-items-center">
                <div className="flex-column">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="h6 w-70 text-left">Campaign Name:</p>
                    <input
                      type="text"
                      className="form-control w-100"
                      placeholder="Enter here"
                      value={campainName}
                      onChange={(e) => setCampainName(e.target.value)}
                    />
                  </div>
                  {errr && <p className="text-danger w-100 text-center ps-5 me-5">{errr}</p>}
                </div>
                <MDBBtn className='ms-2 btn-close' color='none' onClick={() => {
                  setBasicModal(false);
                  setSearchTerm('');
                }}></MDBBtn>
              </div>
            </MDBModalHeader>
            <MDBModalBody className="whatsapptemplateBody">
              <input
                type="text"
                className="form-control"
                placeholder="Search by template name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              {(filteredTemplates && filteredTemplates.length > 0) ? filteredTemplates.map((item, index) => (
                <MDBRow>
                  <MDBCol size='15' key={index}>
                    <MDBCard className="mt-2">
                      <MDBCardBody>
                        <div className="d-flex align-items-start mob-block">
                          <div className="fw-600 d-flex align-items-center w-30" style={{ fontSize: 14 }}>
                            <MDBCheckbox
                              name='flexCheck'
                              value=''
                              id={`flexCheckDefault-${index}`}
                              className="me-2"
                              label={item.elementName}
                              checked={selectedtemp && selectedtemp.templatename === item.elementName}
                              onChange={() => handleTemplateSelection(item)} />
                          </div>
                          <div className="ps-0 w-70 mob-block" dangerouslySetInnerHTML={{ __html: item.bodyOriginal ? item.bodyOriginal : item.body }} />
                        </div>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBCol>
                </MDBRow>
              )) : <p>No Templates Found.</p>}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={cancelhandler}>
                Cancel
              </MDBBtn>
              <MDBBtn onClick={() => handleSendmessage()} >Send Message</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal staticBackdrop tabIndex='-1' open={staticModal} onClose={() => setStaticModal(false)}>
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>
                <h6 className="m-0">
                  {templateinfo ? templateinfo.elementName : ""}
                </h6>
              </MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={handleclose}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <p className="whatsAppTemplate border border-2 rounded-2 p-2">
                {templateinfo ? (templateinfo.bodyOriginal ? templateinfo.bodyOriginal : templateinfo.body) : ""}
              </p>
              <p class="note note-info">
                <strong>Note:</strong> Map the template variables with the application variables.
              </p>
              <div className="d-flex align-items-center justify-content-between">
                <div className="fw-bold">WhatsApp Variables</div>
                <div className="fw-bold w-40 text-center">Application Variables</div>
              </div>

              {whatsappvar.map((waitVar, index) => (<>
                <div className="d-flex align-items-start justify-content-between mt-2" key={index}>
                  <div className="fw-bold w-30 mt-1">{waitVar}<span className="text-danger">*</span></div>
                  <div className="w-40">
                    <select
                      className="form-select p-1 px-2"
                      value={mappings[waitVar] || "Select"}
                      onChange={(e) => handleSelectChange(waitVar, e)}
                    >
                      <option disabled>Select</option>
                      {appVariables && appVariables.length > 0 && appVariables.map((appVar, i) => (
                        <option key={i} value={appVar.value}>{appVar.name}</option>
                      ))}
                      <option value={"customvalue"} >Custom Value</option>
                    </select>
                    {errors[waitVar] && mappings[waitVar] !== "customvalue" && <div className="text-danger">{errors[waitVar]}</div>}
                  </div>

                  {mappings[waitVar] === "customvalue" && (
                    <div className="w-35 ms-2">
                      <input
                        type="text"
                        className="form-control"
                        value={customValues[waitVar] || ""}
                        onChange={(e) => handleCustomValueChange(waitVar, e)}
                        placeholder="Enter custom value"
                      />
                      {errors[waitVar] && <div className="text-danger">{errors[waitVar]}</div>}
                    </div>
                  )}
                </div>
              </>
              ))}

            </MDBModalBody>
            <MDBModalFooter className="pe-2 pb-2">
              <MDBBtn color='secondary' onClick={handleclose}>
                Close
              </MDBBtn>
              <MDBBtn onClick={() => handleSubmit()}>Send</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {alert && (
        <Popup
          title="Confirm message"
          content={
            <>
              <div className="pb-3">
                <span className="fs-6 pb-3">Are you sure you want to send message?</span>
                <div className="overflow_inh d-block py-2 scrollsend"  >
                  {numberData.length > 0 && numberData.map((item) => (<span className="mb-1 chip w-auto d-inline-block"><strong>{item.fname + " " + item.lname}</strong>,<span className="fs-7">{item.number}</span></span>))}
                </div>
              </div>
              <MDBModalFooter>
                <MDBBtn color='secondary' onClick={(e) => setAlert(false)}>
                  Cancel
                </MDBBtn>
                <MDBBtn color='success' onClick={() => handlealert()}>Send</MDBBtn>
              </MDBModalFooter>
            </>
          }
          handleClose={() => setAlert(false)}
        />
      )}

      {messagestatus.toggle && <MDBAlert
        color={messagestatus.status == "success" ? 'success' : 'danger'}
        autohide
        position='top-center'
        delay={5000}
        appendToBody
        open={messagestatus.toggle}
        onClose={() => setMessagestatus({ toggle: false })}
      >
        {messagestatus.message}
      </MDBAlert>}

      <MDBModal open={optSmModal} tabIndex="-1" onClose={() => toggleSegmentClose()}>
        <MDBModalDialog size="md">
          <MDBModalContent>
            <MDBModalBody>
              <h6>Segment</h6>
              {!isNewSegment && isNewSegment !== false ? (
                <div className="d-flex gap-2">
                  <MDBBtn color="primary" onClick={() => setIsNewSegment(false)}>
                    Add to Existing Segment
                  </MDBBtn>
                  <MDBBtn color="success" onClick={() => setIsNewSegment(true)}>
                    Create New Segment
                  </MDBBtn>
                </div>
              ) : isNewSegment ? (
                <div>
                  <MDBInput
                    label="Enter Segment Name"
                    value={segmentName}
                    onChange={(e) => setSegmentName(e.target.value)}
                  />
                  <div className="mt-3 d-flex align-items-center">
                    <MDBRadio
                      name='flexRadioDefault'
                      id='criteria-radio'
                      label='criteria'
                      value='criteria'
                      checked={!toggle}
                      onChange={handleSegmentType}
                    />
                    <MDBRadio
                      name='flexRadioDefault'
                      id='fixed-radio'
                      label='fixed'
                      value='fixed'
                      checked={toggle}
                      onChange={handleSegmentType}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <select
                    value={selectedSegment}
                    className="form-control select-input form-select placeholder-active me-3 shadow-1 form-selectMobile"
                    onChange={(e) => {
                      setSelectedSegment(e.target.value);
                    }}
                  >
                    <option value="">Select Existing Segment</option>
                    {segments.map((seg) => (
                      <option key={seg._id} value={seg._id}>
                        {seg.name}
                      </option>
                    ))}
                  </select>
                  <div className="mt-3 d-flex align-items-center">
                    <MDBRadio
                      name='flexRadioDefault'
                      id='criteria-radio'
                      label='criteria'
                      value='criteria'
                      checked={!toggle}
                      onChange={handleSegmentType}
                    />
                    <MDBRadio
                      name='flexRadioDefault'
                      id='fixed-radio'
                      label='fixed'
                      value='fixed'
                      checked={toggle}
                      onChange={handleSegmentType}
                    />
                  </div>
                </div>
              )}
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => toggleSegmentClose()}>
                Close
              </MDBBtn>
              <MDBBtn onClick={handleSaveSegment}>
                Save
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBAlert
        color="success"
        autohide
        position='top-center'
        delay={4000}
        appendToBody
        open={Alerttxt != ""}
        onClose={() => setAlerttxt("")}
      >
        {Alerttxt}
      </MDBAlert>

      <ImportExcelModal
        isOpen={importPopUp}
        toggleModalClose={popUpClose}
        onDownloadSample={handleSampleMembersDownload}
        onImportFile={importMembersExcelSheet}
        errorMessage={errorMessage}
      />

      <MDBAlert
        color='danger'
        autohide
        position='top-right'
        delay={5000}
        appendToBody
        open={Error2 != ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>

      {
        importError && (
          <MDBToast
            color="danger"
            defaultOpen
            autohide
            position="top-center"
            appendToBody
            width={400}
            delay={5000}
            headerContent={
              <>
                <strong className="me-auto"><h5>Importing Failed!</h5></strong>
              </>
            }
            bodyContent={importError}
          />
        )
      }
    </>
  );
};

export default MManger;